class Style {
  source

  constructor (source) {
    this.source = source
  }

  render (prefix, imageUrls, cssVariables) {
    const renderedCssVariables = this.#renderCssVariables(prefix, cssVariables)
    const withPrefix = this.#addPrefix(prefix)
    const withSufix = this.#addSufix(withPrefix)
    const withReplacedUrls = this.#replaceUrls(withSufix, imageUrls)
    return `<style>${renderedCssVariables}${withReplacedUrls}</style>`
  }

  #addSufix (source) {
    let result = source.replaceAll(/\s?!important;|\s?;$/gm, ' !important;')

    result = result.replaceAll(/url\(.+\)\s?!important;$/gm, (match) => {
      return match.replace(/\s?!important;/, ';')
    })

    return result
  }

  #addPrefix (prefix) {
    // Все вхождения: страничный CSS может переопределять .page после глобального
    // (например, свои CSS-переменные) — replace() оживлял только первый блок.
    const s = this.source.replaceAll('.page {', `#${prefix}.page {`)
    const match = s.match(/^.+\s\{/gm)
    const skipReplacing = (m) => m[0] === '#' || m[0] === '@' || m[0] === '/'
    return match?.reduce((style, m) => {
      const regexp = RegExp('^' + m.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&'), 'gm')
      return skipReplacing(m) ? style : style.replaceAll(regexp, `#${prefix} ` + m)
    }, s) || prefix
  }

  #replaceUrls (source, imageUrls) {
    const regex = /url\(['"]?([^'"()]+)['"]?\)/g
    let result = source
    let m

    while ((m = regex.exec(source)) !== null) {
      if (m.index === regex.lastIndex) {
        regex.lastIndex++
      }

      result = result.replace(m[0], `url(${imageUrls[m[1]]})`)
    }

    return result
  }

  #renderCssVariables (prefix, cssVariables) {
    if (Array.isArray(cssVariables) && cssVariables.length > 0) {
      return `
        #${prefix} {
          ${cssVariables.map((cssVariable) => `${cssVariable.name}: ${cssVariable.value};`).join('\n')}
        }
        #${prefix}[data-color-print="false"] {
          ${cssVariables.map((cssVariable) => `${cssVariable.name}: hsl(from ${cssVariable.value} h 0% l);`).join('\n')}
        }
      `
    } else {
      return ''
    }
  }
}

export { Style }
